
import Reveal from "./Reveal";
import { faqs } from "../data/site";

export default function FAQ() {
  return (
    <section id="dudas" className="relative bg-white">
   
      <div
        className="pointer-events-none absolute inset-x-0 bottom-0 -z-10 h-[320px]
                   bg-[radial-gradient(900px_260px_at_50%_100%,rgba(148,163,184,0.25),transparent_70%)]"
      />

      <div className="mx-auto max-w-5xl px-4 py-16">
        <Reveal>
          <div className="text-center md:text-left">
            <div className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white/80 px-3 py-1 text-[11px] font-medium text-slate-600">
              Dudas frecuentes
              <span className="inline-block h-1.5 w-1.5 rounded-full bg-[var(--brand-3)]" />
            </div>

            <h2 className="mt-3 heading-display text-3xl md:text-4xl font-bold text-slate-900">
              Consultas y preguntas habituales
            </h2>
            <p className="mt-2 text-sm text-slate-600 max-w-xl">
              Resolvemos las dudas más comunes sobre Zentra GPS y Zentra Sistemas,
              para que tengas claridad antes de contratarnos.
            </p>
          </div>
        </Reveal>

        <div className="mt-8 space-y-4">
          {faqs.map((f) => (
            <Reveal key={f.q}>
              <details
                className="
                  group relative overflow-hidden rounded-2xl border border-slate-200/80 bg-white/90
                  px-4 py-3.5 sm:px-5 sm:py-4
                  shadow-[0_14px_40px_rgba(15,23,42,0.06)]
                  transition-all duration-200
                  hover:shadow-[0_20px_60px_rgba(15,23,42,0.12)]
                  hover:-translate-y-[1px]
                  [&[open]]:border-[var(--brand-1)]/40
                "
              >
                
                <div
                  className="pointer-events-none absolute inset-y-0 left-0 w-1.5
                             bg-gradient-to-b from-[var(--brand-1)] via-[var(--brand-3)] to-[var(--brand-4)]"
                />

                <summary
                  className="
                    flex cursor-pointer select-none items-center gap-3 pl-3
                    text-[15px] font-medium text-slate-800
                    focus:outline-none
                    [&::-webkit-details-marker]:hidden
                  "
                >
                  {f.q}
                  <span className="ml-auto flex h-7 w-7 items-center justify-center rounded-full bg-slate-100 text-[var(--brand-1)] transition-colors group-open:bg-[var(--brand-1)]/10">
                    <svg
                      viewBox="0 0 20 20"
                      className="h-4 w-4 transition-transform duration-200 group-open:rotate-180"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        d="M5.23 7.21a.75.75 0 011.06.02L10 10.17l3.71-2.94a.75.75 0 01.92 1.18l-4.24 3.36a.75.75 0 01-.92 0L5.21 8.41a.75.75 0 01.02-1.2z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </span>
                </summary>

                <div className="pt-2 pl-3 pr-2 text-sm text-slate-600">
                  <p>{f.a}</p>
                </div>
              </details>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
